import { createBrowserRouter, RouterProvider} from "react-router-dom";
import LoginForm from './components/LoginForm';
import PasswordResetForm from "./components/PasswordResetForm";
import VerifyResetCode from "./components/VerifyResetCode";
import NewPassword from "./components/NewPassword";
import { ToastProvider } from "./context/ToastContext";

const router = createBrowserRouter([{
  path: "/",
  element: <LoginForm/>,
}, {
  path: "reset",
  element: <PasswordResetForm/>,
}, {
  path: "reset/verify",
  element: <VerifyResetCode/>,
}, {
  path: "reset/new",
  element: <NewPassword/>,
}]);

function App() {
  return (
    <div className="App p-3 h-screen">
      <div className='bg-primary border-round-xl p-4 flex-column md:hidden'>
        <div className='font-bold	text-xl'>
          eztoque
        </div>
      </div>
      <div className='flex h-full'>
        <div className='bg-primary border-round-xl p-5 md:flex flex-column w-6 hidden' style={{ maxWidth: 600 }}>
          <div className='font-bold	text-xl'>
            eztoque
          </div>
          <div className='flex-grow-1 flex flex-column align-content-center justify-content-center'>
            <div className='text-5xl font-semibold mb-3'>
              A solução para o seu serviço
            </div>
            <div className='text-base'>
              Vamos elaborar melhor esse texto depois, comentando sobre alguma funcionalidade interessante a respeito do serviço.
            </div>
          </div>
          <div style={{ 
            backgroundImage: 'url(/img/art_img2.jpg)', 
            height: '40vh', 
            width: '100%', 
            borderRadius: 10,
            backgroundSize: 'cover',
            backgroundPositionY: 'center'
            }}/>
          {/* <img src="/img/art_img.jpg" style={{ height: '40vh', width: '100%' }}/> */}
        </div>
        <div className='flex-grow-1 p-5 flex justify-content-center md:align-items-center'>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </div>
      </div>
    </div>
  );
}

export default App;
